// extracted by mini-css-extract-plugin
module.exports = {"baseBtn":"BaseButton_baseBtn__2Noch","baseAddCircleBtn":"BaseButton_baseAddCircleBtn__1vUtd","iconPlus":"BaseButton_iconPlus__1EPSV"};